import React, { ReactNode } from 'react';
import { AccountContextProvider } from './hooksAccount';
import { AccountOrdersContextProvider } from './hooksAccountOrders';

interface AppProviderProps {
  children: ReactNode;
}

const AppProvider: React.FC<AppProviderProps> = ({ children }: AppProviderProps) => (
  <AccountContextProvider>
        <AccountOrdersContextProvider>
          {children}
        </AccountOrdersContextProvider>
  </AccountContextProvider>
);
export default AppProvider;
